import { Stack } from '@mui/material';
import { type FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const JournalEntryPageSkeleton: FC = () => {
    return (
        <Page back={true} insetEnabled={false}>
            <Stack height="100%" sx={{ background: 'var(--tgui--secondary_bg_color)', paddingTop: 'var(--tg-viewport-content-safe-area-inset-top, 0px)' }}>
                <Stack direction="row" alignItems="center" gap={1.5} sx={{ padding: '16px' }}>
                    <ThemedSkeleton variant="circular" width={24} height={24} />
                    <Stack direction="column" gap={0.5}>
                        <ThemedSkeleton variant="rectangular" width={150} height={24} sx={{ borderRadius: 1 }} />
                        <ThemedSkeleton variant="rectangular" width={120} height={16} sx={{ borderRadius: 1 }} />
                    </Stack>
                </Stack>

                <Stack sx={{ flex: 1, padding: '16px', overflow: 'auto' }} gap={2}>
                    <Stack gap={1}>
                        <ThemedSkeleton variant="rectangular" width={60} height={16} sx={{ borderRadius: 1 }} />
                        <ThemedSkeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 1 }} />
                    </Stack>
                    <ThemedSkeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1 }} />
                </Stack>
            </Stack>
        </Page>
    );
};

